module.exports = __webpack_public_path__ + "new-customers-light-bg.a8afd617d5803e05a932f3bccde028f9.png";